import { Authenticationservice } from './../../services/authentication.service';
import { Component, OnInit } from '@angular/core';
import axios from 'axios';

@Component({
  selector: 'app-printaskformoney',
  templateUrl: './printaskformoney.component.html',
  styleUrls: ['./printaskformoney.component.css']
})
export class PrintaskformoneyComponent implements OnInit {

  time:any;
  zone:any;
  userlevel: any;

  constructor(private auth:Authenticationservice) {
    let userdata;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.supcode = userdata.supcode;
    this.supname = userdata.supname;
    this.userlevel = userdata.userlevel;

    const date = new Date()
    const result = date.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
    this.time = result;
   }
   used:any;
  ngOnInit(): void {
    let data = localStorage.getItem('fmcodedataforaskmoney');
    this.used = JSON.parse(data);
    // console.log(this.used);
    this.getdatafarmer(this.used);
  }

  dataone:any;
  datafamer:any;
  supname:any;
  supcode:any;
  summoney:any;
  
  getdatafarmer(fmcode){
    // console.log(fmcode)
    let doc_status = 0;
    if (this.userlevel == 15) { doc_status = 2 };
    this.getratedata(fmcode);
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_getfinance6566w?doc_status=" + doc_status +"&FMCODE_B1='" + fmcode + "'";
    axios.get(url)
    .then(res => {
    this.dataone = res.data.recordset;
    this.summoney = (this.dataone.map(el => { return el.money_amt})).reduce((a, b) => a + b, 0);
    }).catch(err => { throw(err); })

    let url2 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/getfmdata?fmcode_b1=" + fmcode ;
    axios.get(url2)
    .then(res => {
    this.datafamer = res.data.recordset;
    }).catch(err => { throw(err); })

    setTimeout(() => {
      window.print();
    }, 2500);
  }

  retadata:any;
  getratedata(fmcode){

    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/v_bt6566farmer_w?FMCODE_B1=%27"+ fmcode +"%27";
    axios.get(url)
    .then(res => {
    this.retadata = res.data.recordset;
    }).catch(err => { throw(err); })

  }
}
